import {
  DetailRequirement,
  EngagementTaskTrait,
  EngagementTaskTraitBooleanParams,
  MultipleTaskTraitDetail,
  SingularTaskTraitDetail,
} from '@cibo/core'
import { FormControlLabel, Radio, RadioGroup } from '@mui/material'
import { useCallback, useState } from 'react'
import { useProgramEngagementContext } from '../../../../context'

type DataEntryRadioGroupProps = {
  detailRequirement?: DetailRequirement
  onChange: (detail: MultipleTaskTraitDetail | SingularTaskTraitDetail) => void
  traitConfig: EngagementTaskTrait
  traitDetailValue: any
  immutable?: boolean
}

export const DataEntryRadioGroup = ({
  detailRequirement,
  onChange,
  traitConfig,
  traitDetailValue,
  immutable,
}: DataEntryRadioGroupProps) => {
  const { taskData } = useProgramEngagementContext()

  const traitStatus = taskData.data?.getTraitStatus(traitConfig.traitId)
  const params = traitStatus?.params

  const options = (params as EngagementTaskTraitBooleanParams)?.options ?? []
  const optionsByValue: Record<string, { value: any }> = options.reduce(
    (acc, option) => ({
      ...acc,
      [`${option.value}`]: option,
    }),
    {}
  )

  const [radioValue, setRadioValue] = useState(traitDetailValue)

  const handleChangeDetail = (detail: MultipleTaskTraitDetail | SingularTaskTraitDetail) => {
    onChange(detail)
  }

  const detailForValue = useCallback(
    (value: any) => {
      if (detailRequirement?.year) {
        return {
          traitId: traitConfig.traitId,
          year: detailRequirement.year,
          value,
        }
      }
      return { traitId: traitConfig.traitId, value }
    },
    [traitConfig, detailRequirement]
  )

  return (
    <RadioGroup
      value={radioValue}
      onChange={(_, radioValue) => {
        const option = optionsByValue[radioValue]

        setRadioValue(option.value)
        handleChangeDetail(detailForValue(option.value))
      }}
    >
      {options.map(option => (
        <FormControlLabel
          data-testid={`radio-${option.value}`}
          key={`${option.value}`}
          disabled={immutable}
          value={option.value}
          control={<Radio />}
          label={option.label}
        />
      ))}
    </RadioGroup>
  )
}
